import gql from 'graphql-tag';

export const resetSupplierMemberPassword = gql`
  mutation supplierMemberResetPassword($input: IdInput!) {
    supplierMemberResetPassword(input: $input) {
      success
    }
  }
`;
